import { useNavigate } from "react-router-dom";
import type { SubjectDto } from "@mmm/contracts";
import { ColorDot } from "@mmm/ui";
interface SidebarSubjectRowProps {
  subject: SubjectDto;
  /**
   * Whether this row is the current location — NOT merely whether its subject
   * is open. A subject with a chapter selected under it is open but not
   * selected, so only one row in the tree ever reads as current.
   */
  isSelected: boolean;
}

export function SidebarSubjectRow({ subject, isSelected }: SidebarSubjectRowProps) {
  const navigate = useNavigate();

  return (
    <button
      type="button"
      className={`mmm-sidebar-tree-row mmm-sidebar-subject-row ${isSelected ? "is-active" : ""}`.trim()}
      title={subject.title}
      onClick={() => navigate(`/subjects/${subject.id}`)}
    >
      <ColorDot color={subject.color} className="mmm-sidebar-subject-dot" />
      <span className="mmm-sidebar-subject-name">{subject.title}</span>
    </button>
  );
}
